module.exports = __webpack_public_path__ + "632bfea5056e1ba195e472ffed37eaa5.svg";